import styled from "styled-components";

export const Container = styled.div``;

export const Content = styled.div`
  display: flex;
  flex-direction: row;

  @media ${({ theme }) => theme.devices.tablet} {
    flex-direction: column;
  }
`;

export const SearchContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin: 20px 0;

  @media ${({ theme }) => theme.devices.tablet} {
    flex-direction: column;
  }
`;

export const TotalResults = styled.span`
  font-size: ${({ theme }) => theme.fontSize.sm};
  color: ${({ theme }) => theme.colors.gray.dark};
  white-space: nowrap;
  margin-left: 100px;
  margin-top: auto;
  @media ${({ theme }) => theme.devices.tablet} {
    margin-top: 20px;
    margin-left: 0;
    text-align: right;
  }
`;

export const Filters = styled.div`
  min-width: 30%;
  width: 30%;

  @media ${({ theme }) => theme.devices.tablet} {
    width: 100%;
  }
`;

export const ListContainer = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
`;

export const List = styled.div`
  flex-grow: 1;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  align-self: flex-start;
  margin-left: 20px;

  @media ${({ theme }) => theme.devices.tablet} {
    margin-left: 0;
  }
`;

export const NoResults = styled.span`
  margin-top: 20px;
  text-align: center;
  font-family: ${({ theme }) => theme.fonts.inter};
  color: ${({ theme }) => theme.colors.gray.dark};
  letter-spacing: 1px;
  flex-grow: 1;
`;

export const EmptyItem = styled.div`
  width: 280px;
  height: 130px;
  margin-bottom: 20px;
`;

export const MobileFilterContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
`;

export const ButtonContainer = styled.div`
  display: flex;
  position: relative;
  justify-content: center;
  text-align: center;
  align-items: center;
  gap: 10px;
  width: calc(50% - 2px);
  border: 1px solid ${({ theme }) => theme.colors.gray.light};
  padding: 5px;
  font-size: ${({ theme }) => theme.fontSizePx.mm};
  font-family: ${({ theme }) => theme.fonts.inter};
  font-weight: 500;
  color: ${({ theme }) => theme.colors.grayNew.gray3};
  overflow: visible;
  height: 24px;

  @media ${({ theme }) => theme.devices.tabletS} {
    height: 20px;
    font-size: ${({ theme }) => theme.fontSizePx.sm};
  }
`;

export const SelectorContainer = styled.div`
  display: flex;
  // height: 100%;
  align-self: center;
  align-items: center;
  justify-content: center;
`;

export const Expand = styled.div`
  margin-left: auto;
  font-size: 12px;
  align-self: center;
`;
